var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSpeedometor = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M9.395 1.329A7.68 7.68 0 0 1 16.681 9l-.01.394a7.68 7.68 0 0 1-7.67 7.286l-.396-.01A7.68 7.68 0 0 1 1.33 9.396l-.01-.394A7.68 7.68 0 0 1 9.002 1.32zm.23 2.87h-1.25V2.6A6.43 6.43 0 0 0 2.6 8.376h1.6v1.25H2.6A6.43 6.43 0 0 0 8.376 15.4v-1.599h1.25V15.4A6.43 6.43 0 0 0 15.4 9.626h-1.599v-1.25H15.4a6.43 6.43 0 0 0-5.774-5.777zm3.178 1.883-2.078 2.077c.124.254.196.539.196.84l-.01.197A1.92 1.92 0 0 1 9 10.92l-.197-.01A1.92 1.92 0 0 1 7.09 9.196L7.08 9c0-1.06.86-1.92 1.92-1.92l.197.01q.346.036.644.184l2.079-2.077zM9 8.33a.67.67 0 1 0 0 1.34.67.67 0 0 0 0-1.34" }) }))); };
export default SvgSpeedometor;
